export const popupContent = {
  title: 'Планировка почти ваша ',
  text: 'Оставьте номер телефона, и мы отправим подробную информацию по выбранной планировке:<span> стоимость, доступность и условия покупки.</span>',
  buttonLabel: 'Получить информацию',
  consentLabel: 'я даю согласие на получение рекламных и маркетинговых коммуникаций',
  disclaimer:
    'нажимая на кнопку «Получить информацию», вы подтверждаете, что принимаете условия обработки ваших персональных данных в соответствии с <a href="/privacy">Политикой обработки персональных данных</a> и даете свое Согласие на обработку персональных данных',
};
